import { render, staticRenderFns } from "./parleyDefaultSetup.vue?vue&type=template&id=6c3135dc&"
import script from "./parleyDefaultSetup.vue?vue&type=script&lang=js&"
export * from "./parleyDefaultSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports